<!-- Backdrop (not focusable - visual dismiss layer) -->
 
<div
  class="hc-modal-backdrop"
  [class.hc-modal-backdrop--visible]="isVisible"
  (click)="onBackdropClick($event)"
  aria-hidden="true"
  >
  <!-- Modal Dialog -->
  <div
    #modalDialog
    class="hc-modal"
    [class.hc-modal--visible]="isVisible"
    [ngClass]="[sizeClass, centeredClass, config.cssClass || '']"
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    [attr.aria-labelledby]="config.title ? 'modal-title' : null"
    >
    <!-- Header -->
    @if (config.title || config.closable !== false) {
      <div class="hc-modal__header">
        @if (config.title) {
          <h2 class="hc-modal__title" id="modal-title">
            {{ config.title }}
          </h2>
        }
        @if (config.closable !== false) {
          <button
            type="button"
            class="hc-modal__close"
            (click)="close()"
            aria-label="Close"
            >
            <lucide-icon name="x"></lucide-icon>
          </button>
        }
      </div>
    }

    <!-- Body -->
    <div class="hc-modal__body">
      <!-- Custom content -->
      <ng-container #contentContainer></ng-container>

      <!-- Confirm dialog content -->
      @if (isConfirmDialog) {
        <p class="hc-modal__message">{{ confirmMessage }}</p>
      }
    </div>

    <!-- Footer (confirm dialog only) -->
    @if (isConfirmDialog) {
      <div class="hc-modal__footer">
        <button
          type="button"
          class="hc-modal__btn hc-modal__btn--secondary"
          (click)="onCancel()"
          >
          {{ cancelText }}
        </button>
        <button
          type="button"
          class="hc-modal__btn"
          [class.hc-modal__btn--primary]="confirmVariant === 'primary'"
          [class.hc-modal__btn--danger]="confirmVariant === 'danger'"
          (click)="onConfirm()"
          >
          {{ confirmText }}
        </button>
      </div>
    }
  </div>
</div>
